module.exports = __webpack_public_path__ + "img/pen6.a06a5986.svg";